import React from 'react';
import { WEALTHIEST_DATA } from './data';
import Ledger from '../../Components/Ledger/Ledger';

const entries = WEALTHIEST_DATA.map((person: any) => ({
   name: person.name,
   worth: person.net_worth,
   meta: [person.country, person.companies?.join(', ')].filter(Boolean).join('  •  '),
   description: person.description,
   image: person.profile ? `${process.env.PUBLIC_URL}/profiles/${person.profile}` : undefined,
}));

const WealthiestPage = () => <Ledger entries={entries} unit="Net worth" />;

export default WealthiestPage;
